import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M4.6859375,2.94328125 L9.99765625,2.94328125 L9.99765625,5.99484375 L4.6859375,5.99484375 L4.6859375,2.94328125 Z M4.6978125,7.544375 L9.75421875,7.544375 L9.75421875,16.6515625 L4.6978125,16.6515625 L4.6978125,7.544375 Z M13.070625,0.296875 L1.65578125,0.296875 L1.65578125,19.703125 L18.339375,19.703125 L18.3442188,16.91625 L18.3442188,5.5584375 L13.070625,0.296875 Z M12.8321875,2.21609375 L13.2017188,2.58578125 L16.4273438,5.80421875 L12.8321875,5.80421875 L12.8321875,2.21609375 Z M16.8135937,18.1773437 L3.1815625,18.1773437 L3.1815625,1.82265625 L11.3040625,1.82265625 L11.3040625,7.3275 L11.3398437,7.3275 L11.3398437,7.32984375 L16.8135937,7.32984375 L16.8135937,18.1773437 Z M11.3910671,9.04640625 L15.3832812,9.04640625 L15.3832812,10.5721875 L11.3910671,10.5721875 L11.3910671,9.04640625 L11.3910671,9.04640625 Z M11.3910671,12.0860937 L15.3832812,12.0860937 L15.3832812,13.611875 L11.3910671,13.611875 L11.3910671,12.0860937 Z M11.3832812,15.1495312 L15.3753929,15.1495312 L15.3753929,16.6754687 L11.3832812,16.6754687 L11.3832812,15.1495312 Z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </svg>
  )
}

const CityIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default CityIcon
